export default __webpack_public_path__ + "static/media/Model 3.c2ea6cff.png";